import api from '../../plugins/api';

const getStockReportFilters = () => {
  return api.get('/api/crm/cars/stockReport/filters');
};

export default getStockReportFilters;
